import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap, timer } from 'rxjs';
import { CommonService } from './common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from './app-config.service';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
    public currentVersion?: string;
    appConfig: any;
    intervalDuration: number = 0;

    constructor(private readonly http: HttpClient, private readonly commonService: CommonService, private readonly snackBar: MatSnackBar, private readonly translate: TranslateService, private readonly appConfigService: AppConfigService) {
        this.translate.addLangs(['en']);
        this.translate.setDefaultLang('en');
        this.translate.use('en');
        this.appConfig = appConfigService.config;
        this.intervalDuration = this.appConfig?.webAppConfig?.appVersionPollingInterval || 30000;
    }

    init(): void {
        timer(0, this.intervalDuration).subscribe(() => {
            this.checkVersion();
        });
    }

    checkVersion(): void {
        const timestamp = new Date().getTime();

        this.http.get<{ version: string }>(
            `assets/version.json?t=${timestamp}`,
            { headers: { 'Cache-Control': 'no-cache' } }
        ).subscribe(response => {

            if (!this.currentVersion) {
                this.currentVersion = response.version;
                this.commonService.ProjectLSData.appVersion = response.version;
                this.commonService.setProjectLSData();
                return;
            } else {
                this.commonService.ProjectLSData.appVersion = this.currentVersion;
                this.commonService.setProjectLSData();
            }

            if (this.currentVersion !== response.version) {
                this.commonService.updatedAppVersion = response.version;

                if (window.location.pathname === '/login') {
                    this.reloadApp();
                } else if (!this.commonService.showRefreshPanel) {
                    this.commonService.showRefreshPanel = true;

                    const snackRef = this.snackBar.open(
                        this.translate.instant('GENERIC_MSG.COMMON.APP_NEW_VERSION'), 'REFRESH', {
                        horizontalPosition: 'start',
                        verticalPosition: 'bottom',
                        panelClass: ['appVersionRefreshPanel']
                    });

                    snackRef.onAction().subscribe(() => {
                        snackRef.dismiss();
                        this.commonService.reloadWindow();
                    });
                }
            }
        });
    }

    init1(): void {
        let timestamp = new Date().getTime();
        timer(0, this.intervalDuration) // every 30 seconds
            .pipe(
                switchMap(() =>
                    this.http.get<{ version: string }>(
                        `assets/version.json?t=${timestamp}`,
                        { headers: { 'Cache-Control': 'no-cache' } }
                    )
                )
            )
            .subscribe(response => {
                if (!this.currentVersion) {
                    this.currentVersion = response.version;
                    this.commonService.ProjectLSData.appVersion = this.currentVersion;
                    this.commonService.setProjectLSData();
                    return;
                } else {
                    this.commonService.ProjectLSData.appVersion = this.currentVersion;
                    this.commonService.setProjectLSData();
                }

                if (this.currentVersion !== response.version) {
                    this.commonService.updatedAppVersion = response.version;

                    if (window.location.pathname == "/login") {
                        this.reloadApp();
                    } else if (!this.commonService.showRefreshPanel) {
                        this.commonService.showRefreshPanel = true;
                        const snackRef = this.snackBar.open(this.translate.instant("GENERIC_MSG.COMMON.APP_NEW_VERSION"), 'REFRESH', {
                            horizontalPosition: 'start',
                            verticalPosition: 'bottom',
                            panelClass: ['appVersionRefreshPanel']
                        });
                        snackRef.onAction().subscribe(() => {
                            snackRef.dismiss();
                            this.commonService.reloadWindow();
                        });
                    }
                }
            }, (err: any) => {
                let x = 0;
            });
    }

    reloadApp(): void {
        this.commonService.ProjectLSData.appVersion = this.commonService.updatedAppVersion;
        this.commonService.setProjectLSData();
        window.location.reload();
    }
}
